import { TFunction } from 'i18next';
import { toast } from 'react-toastify';

export const showPlatformApiError = (error: unknown, t: TFunction) => {
  const message = error instanceof Error ? error.message : t('anErrorOccurred');
  toast.error(message);
};
